export type WorkspaceSection = 'memories' | 'map';

export const WORKSPACE_LAST_SECTION_STORAGE_KEY = 'workspace:lastTab';

export function rememberWorkspaceSection(section: WorkspaceSection): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(WORKSPACE_LAST_SECTION_STORAGE_KEY, section);
}

export function readRememberedWorkspaceSection(): WorkspaceSection {
  if (typeof window === 'undefined') return 'memories';
  const value = window.localStorage.getItem(WORKSPACE_LAST_SECTION_STORAGE_KEY);
  return value === 'map' ? 'map' : 'memories';
}

export function workspaceSectionPath(
  section: WorkspaceSection,
  namespace: 'spaces' | 'workspace'
): string {
  if (namespace === 'workspace') {
    return section === 'map' ? '/workspace/map' : '/workspace';
  }
  return section === 'map' ? '/spaces/map' : '/spaces/memories';
}
